import {Toast} from 'vant'


export default {
    data() {
        return {
            T:[],
            doTopicIndex:0
        }
    },
    computed: {
        // 1123456

    },
    methods: {
        swipeTopic(isRight){
            if(0 === isRight){//上
                if(this.doTopicIndex === 0){
                    Toast('已经是第一题了');
                    return
                }

                this.doTopicIndex --;
                this.$nextTick(_=>{
                    window.scroll(0,0);
                    document.body.scrollTop = 0;//解决ios莫名其妙响应错位并且出去空白的问题
                    this.onlyPlayOneAudio();
                });

                if(this.swipeTopicHook && typeof (this.swipeTopicHook) === "function"){
                    this.swipeTopicHook(0)
                }

            }
            if(1 === isRight){//下一题
                if(this.doTopicIndex === this.T.length -1){
                    Toast('已经是最后一题了');
                    return
                }

                this.doTopicIndex ++;
                this.$nextTick(_=>{
                    window.scroll(0,0);
                    document.body.scrollTop = 0;//解决ios莫名其妙响应错位并且出去空白的问题
                    this.onlyPlayOneAudio();
                });

                if(this.swipeTopicHook && typeof (this.swipeTopicHook) === "function"){
                    this.swipeTopicHook(1)
                }
            }
        },
        //多个音频播放控制、
        onlyPlayOneAudio(){
            let audioDom = document.querySelectorAll('audio');
            if(audioDom.length < 2) return;
            function pauseAll() {
                let self = this;
                [].forEach.call(audioDom, function (i) {
                    // 将audios中其他的audio全部暂停
                    i !== self && i.pause();
                })
            }
            [].forEach.call(audioDom, function (i) {
                i.addEventListener("play", pauseAll.bind(i));
            })
        },

    },
    created() {

    }
}
